import { Box, Typography } from "@mui/material";

const BlockItem = ({
    title,
    value,
    Component,
}: {
    title: string;
    value: React.ReactNode;
    Component?: React.ReactNode;
}) => {
    return (
        <Box className="flex flex-col gap-1">
            <Typography
                variant="textXs"
                sx={{
                    color: "textColors.666",
                }}
            >
                {title}
            </Typography>
            {Component ? (
                Component
            ) : (
                <Typography
                    variant="textSm"
                    sx={{
                        fontWeight: "500",
                        color: "textColors.333",
                    }}
                >
                    {value}
                </Typography>
            )}
        </Box>
    );
};

export default BlockItem;
